import React from "react";
import PatientInformation from "./PatientInformation";
import PatientSearch from "./PatientSearch";

export default function Patient({ onChange, onError }) {
  const [patient, setPatient] = React.useState(null);

  return (
    <>
      <PatientSearch
        onSuccess={(patient) => {
          setPatient(patient);
          onChange(patient);
        }}
        onError={onError}
      />
      {patient && <PatientInformation patient={patient} />}
    </>
  );
}
